import * as types from "../../mutation-types";
import * as Vue from "vue"
import {addOrUpdateItem, removeItem} from "../../helpers";

export default {
    [types.SET_ROLES]: (state, roles) => state.items = roles,
    [types.ADD_OR_UPDATE_ROLE]: (state, role) => addOrUpdateItem(state, role),
    [types.REMOVE_ROLE]: (state, item) => removeItem(state, item)
}
